import React, { useState } from "react";
import "./Hero.css";
import { useApp } from "../../AppContext/AppContext";
import VideoCard from "../VideoCard/VideoCard";
import VideoDownloaderCard from "../AppCard/VideoDownloaderCard";
import Lottie from 'react-lottie';
import loadingAnimation from '../loading.json'; // Ensure this path is correct
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Hero = () => {
  const { 
    selectedApp, 
    currentColor, 
    validateUrl, 
    videoCardKey,
    isVideoCardVisible,
    setIsVideoCardVisible,
    searchInput,
    setSearchInput
  } = useApp();
  const [videoData, setVideoData] = useState(null);
  const [error, setError] = useState('');
  const [loadingFetch, setLoadingFetch] = useState(false);

  const fetchVideoInfo = async () => {
    // Clear any existing states
    setVideoData(null);
    setIsVideoCardVisible(false);
    setError('');

    if (!searchInput) {
      setError("Please enter a video URL.");
      toast.error("Please enter a video URL.", {
        icon: "❗",
        style: {
          backgroundColor: "#2b2b2b",
          color: "#fff",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #e74c3c",
          fontSize: '14px',
          marginTop: "5rem",
          marginRight: '20px',
        },
        progressStyle: {
          background: "#e74c3c",
        },
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setTimeout(() => setError(""), 3000);
      return;
    }

    // Validate URL against selected app
    const { isValid, message } = validateUrl(searchInput);
    if (!isValid) {
      setError(message);
      toast.error(message, {
        icon: "❗",
        style: {
          backgroundColor: "#2b2b2b",
          color: "#fff",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #e74c3c",
          fontSize: '14px',
          marginTop: "5rem",
          marginRight: '20px',
        },
        progressStyle: {
          background: "#e74c3c",
        },
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setTimeout(() => setError(""), 3000);
      return;
    }

    setLoadingFetch(true);
    try {
      let apiUrl;
      let requestBody;

      // Check if the URL contains "instagram" or "snapchat"
      if (searchInput.toLowerCase().includes('instagram')) {
        apiUrl = 'https://instaapi.zagtechnology.com/isg-dl/index.php';
        requestBody = { url: searchInput };
      } else if (searchInput.toLowerCase().includes('snapchat')) {
        apiUrl = 'https://instaapi.zagtechnology.com/snapchat-dl';
        requestBody = { url: searchInput };
      } else if (searchInput.toLowerCase().includes('flic')) {
        apiUrl = 'https://instaapi.zagtechnology.com/flickr-dl';
        requestBody = { url: searchInput };
      } else if (searchInput.toLowerCase().includes('likee')) {
        apiUrl = 'https://fbapi.gurrutechnology.com/facebook-api/app/likee-api.php';
        requestBody = { url: searchInput };
      } else {
        apiUrl = 'https://allvideoapi.zagtechnology.com/all-video-downloader/all-video-api.php';
        requestBody = { 
          url: searchInput,
          // platform: selectedApp?.toLowerCase() || 'instagram'
        };
      }
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`Server responded with status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API Response:', data);

      // Check if we have valid links with content
      const hasValidLinks = data.links && (
        (data.links.hd_url && data.links.hd_url !== '') ||
        (data.links.sd_url && data.links.sd_url !== '') ||
        (data.links.audio_url && data.links.audio_url !== '')
      );

      if (hasValidLinks) {
        // Handle thumbnail URL
        let thumbnailUrl = data.thumbnailUrl;
        
        // Always set default thumbnail if no valid thumbnail URL
        if (!thumbnailUrl || thumbnailUrl === "" || thumbnailUrl === null || thumbnailUrl === "undefined") {
          const modifiedData = {
            ...data,
            thumbnailUrl: '/assets/thumbnail.png',
            links: {
              hd_url: data.links?.hd_url || null,
              sd_url: data.links?.sd_url || null,
              audio_url: data.links?.audio_url || null,
              hd_size_mbs: data.links?.hd_size_mbs || '0 MB',
              sd_size_mbs: data.links?.sd_size_mbs || '0 MB',
              audio_size_mbs: data.links?.audio_size_mbs || '0 MB'
            }
          };
          setVideoData(modifiedData);
          setIsVideoCardVisible(true);
        } else {
          // Try to load the provided thumbnail
          const img = new Image();
          img.onload = () => {
            const modifiedData = {
              ...data,
              thumbnailUrl: thumbnailUrl,
              links: {
                hd_url: data.links?.hd_url || null,
                sd_url: data.links?.sd_url || null,
                audio_url: data.links?.audio_url || null,
                hd_size_mbs: data.links?.hd_size_mbs || '0 MB',
                sd_size_mbs: data.links?.sd_size_mbs || '0 MB',
                audio_size_mbs: data.links?.audio_size_mbs || '0 MB'
              }
            };
            setVideoData(modifiedData);
            setIsVideoCardVisible(true);
          };
          img.onerror = () => {
            // Use default thumbnail if loading fails
            const modifiedData = {
              ...data,
              thumbnailUrl: '/assets/thumbnail.png',
              links: {
                hd_url: data.links?.hd_url || null,
                sd_url: data.links?.sd_url || null,
                audio_url: data.links?.audio_url || null,
                hd_size_mbs: data.links?.hd_size_mbs || '0 MB',
                sd_size_mbs: data.links?.sd_size_mbs || '0 MB',
                audio_size_mbs: data.links?.audio_size_mbs || '0 MB'
              }
            };
            setVideoData(modifiedData);
            setIsVideoCardVisible(true);
          };
          img.src = thumbnailUrl;
        }
      } else {
        setError("No valid media found or video has no accessible link.");
        toast.error("No valid media found or video has no accessible link.", {
          icon: "❗",
          style: {
            backgroundColor: "#2b2b2b",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e74c3c",
            fontSize: '14px',
            marginTop: "5rem",
            marginRight: '20px',
          },
          progressStyle: {
            background: "#e74c3c",
          },
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setTimeout(() => setError(""), 3000);
      }
    } catch (err) {
      console.error('Error fetching video data:', err);
      if (err.message.includes('Failed to fetch')) {
        setError("Network error. Please check your internet connection and try again.");
        toast.error("Network error. Please check your internet connection and try again.", {
          icon: "❗",
          style: {
            backgroundColor: "#2b2b2b",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e74c3c",
            fontSize: '14px',
            marginTop: "5rem",
            marginRight: '20px',
          },
          progressStyle: {
            background: "#e74c3c",
          },
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setTimeout(() => setError(""), 3000);
      } else if (err.message.includes('ERR_BLOCKED_BY_RESPONSE')) {
        setError("Unable to access content. Please try using a different video URL.");
        toast.error("Unable to access content. Please try using a different video URL.", {
          icon: "❗",
          style: {
            backgroundColor: "#2b2b2b",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e74c3c",
            fontSize: '14px',
            marginTop: "5rem",
            marginRight: '20px',
          },
          progressStyle: {
            background: "#e74c3c",
          },
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setTimeout(() => setError(""), 3000);
      } else {
        setError("Failed to fetch video information. Please try again later.");
        toast.error("Failed to fetch video information. Please try again later.", {
          icon: "❗",
          style: {
            backgroundColor: "#2b2b2b",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e74c3c",
            fontSize: '14px',
            marginTop: "5rem",
            marginRight: '20px',
          },
          progressStyle: {
            background: "#e74c3c",
          },
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setTimeout(() => setError(""), 3000);
      }
    } finally {
      setLoadingFetch(false);
    }
  };

  const handleCloseVideoCard = () => {
    setIsVideoCardVisible(false);
    setVideoData(null);
    setSearchInput('');
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText(); // Read text from clipboard
      setSearchInput(text); // Set the copied text to the searchInput state
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
      setError('Failed to paste from clipboard.');
      setTimeout(() => setError(""), 3000);
    }
  };

  return (
    <section className="hero">
      <div className="heading">
      <h1 className="h1">
        {selectedApp ? (
          <>{selectedApp} <span style={{ color: currentColor }}>Video Downloader</span></>
        ) : (
          <>All Video <span style={{ color: currentColor }}>Downloader</span></>
        )}
      </h1>
      </div>
      <p className="hero-p">
        Free online video downloader for {selectedApp || 'Dailymotion, Twitter, Tiktok, Instagram, Facebook'} and many other sites.
      </p>
      {!isVideoCardVisible && (
        <>
        <div className="input-container-main ">
          <div className="download-box">
            <div className="input-container">
              <input className="input"
                type="text"
                placeholder={`Paste the ${selectedApp || 'video'} link here...`}
                aria-label="Video URL input"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <div className="paste-icon" onClick={handlePaste}>
                <img src="/assets/pasteIcon.png" alt="Paste Icon" className="paste-icon-img" />
              </div>
            </div>
            <button 
              className="download-btn"
              style={{ 
                background: currentColor,
                opacity: 1 
              }}
              onClick={fetchVideoInfo}  
            >
              {loadingFetch ? (
                <Lottie 
                  className="loading-animation"
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loadingAnimation,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice'
                    }
                  }}
                  isClickToPauseDisabled={true}
                />
              ) : (
                "Download"
              )}
            </button>
          </div>
          </div>
          {error && <p className="error-message">{error}</p>}
          <p className="terms">
           <span className="terms-black-parag"> By using our service you accept our </span>
            <a 
              href="https://vidoxe.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: currentColor }}
            >
              Terms of Service
            </a> <span className="terms-black-parag"> and </span>
            <a 
              href="https://vidoxe.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: currentColor }}
            >
              Privacy Policy
            </a>
          </p>
          <VideoDownloaderCard />
          
        </>
      )}
      {isVideoCardVisible && videoData && (
        <VideoCard 
          key={videoCardKey}
          videoData={videoData} 
          onClose={handleCloseVideoCard} 
        />
      )}
      <ToastContainer
        className="toast-container hide-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </section>
  );
};

export default Hero;
